/**
 * Servicio independiente para el Formulario de Mantenimiento TAMEP
 */
export const MantenimientoReporte = {
  generarHTML(ticket, intervencion) {
    const i = intervencion;
    return `
      <html>
        <head>
          <style>
            .container { font-family: Arial, sans-serif; width: 210mm; padding: 10mm; margin: auto; font-size: 10px; }
            .header-table { width: 100%; margin-bottom: 5px; }
            .title { text-align: center; font-weight: bold; border: 1px solid #000; padding: 4px; margin: 5px 0; background: #f0f0f0; }
            .border-table { width: 100%; border-collapse: collapse; border: 1px solid #000; margin-bottom: 5px; }
            .border-table td { border: 1px solid #000; padding: 4px; }
            .bg-gray { background: #eee; font-weight: bold; font-size: 9px; }
            .check-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 5px; padding: 5px; border: 1px solid #000; }
            .box { width: 10px; height: 10px; border: 1px solid #000; display: inline-block; text-align: center; line-height: 10px; font-size: 8px; }
            .signature-table { width: 100%; margin-top: 30px; text-align: center; }
            .sig-line { border-top: 1px solid #000; width: 80%; margin: 30px auto 5px auto; }
          </style>
        </head>
        <body>
          <div class="container">
            <table class="header-table">
              <tr>
                <td><b>tamep</b> [cite: 47]<br>EMPRESA PÚBLICA<br>GERENCIA DE INFORMATICA Y COMUNICACIONES [cite: 48]<br>BOLIVIA [cite: 49]</td>
                <td style="text-align: right;">G.I. y CC. EP-TAM N°: <b>${ticket.num_ticket}</b> [cite: 50, 51]</td>
              </tr>
            </table>

            <div class="title">FORMULARIO DE SECCION MANTENIMIENTO </div>

            <table class="border-table">
              <tr class="bg-gray"><td colspan="2">DATOS DEL SOLICITANTE [cite: 54, 56]</td></tr>
              <tr><td><b>Repartición:</b> ${ticket.regional || ''} [cite: 53]</td><td><b>Nombre:</b> ${ticket.solicitante_nombre} [cite: 57]</td></tr>
              <tr><td><b>Cargo:</b> ${ticket.solicitante_cargo || ''} [cite: 58]</td><td><b>Fecha:</b> ${new Date(ticket.fecha_solicitud).toLocaleDateString()}</td></tr>
            </table>

            <table class="border-table">
              <tr><td><b>EQUIPO:</b> ${ticket.activo_nombre} [cite: 61]</td><td><b>MODELO:</b> ${ticket.activo_modelo} [cite: 72]</td></tr>
            </table>

            <div class="bg-gray" style="border: 1px solid #000; padding: 3px;">DIAGNÓSTICO [cite: 74]</div>
            <div class="check-grid" style="border-top: none;">
              <div><span class="box">${i.tipo_mantenimiento === 'Preventivo' ? 'X' : ''}</span> Preventivo [cite: 86]</div>
              <div><span class="box">${i.tipo_mantenimiento === 'Correctivo' ? 'X' : ''}</span> Correctivo [cite: 78, 89]</div>
              <div><span class="box">${i.categoria_falla === 'Hardware' ? 'X' : ''}</span> Hardware [cite: 76]</div>
              <div><span class="box">${i.categoria_falla === 'Software' ? 'X' : ''}</span> Software [cite: 77, 96]</div>
              <div><span class="box">${i.modalidad === 'Taller' ? 'X' : ''}</span> En Taller [cite: 88]</div>
              <div><span class="box">${i.modalidad === 'Sitio' ? 'X' : ''}</span> En Sitio [cite: 95]</div>
            </div>

            <div class="bg-gray" style="border: 1px solid #000; margin-top: 5px; padding: 3px;">DETALLES DE REPARACIÓN [cite: 98]</div>
            <div style="border: 1px solid #000; border-top: none; padding: 8px; min-height: 80px;">${i.detalles_reparacion}</div>

            <div class="bg-gray" style="border: 1px solid #000; margin-top: 5px; padding: 3px;">CONTROL DE CALIDAD [cite: 102]</div>
            <div class="check-grid" style="border-top: none;">
              <div><span class="box">X</span> Sistema operativo [cite: 103]</div>
              <div><span class="box">X</span> Microsoft Office [cite: 104]</div>
              <div><span class="box">X</span> Antivirus [cite: 105]</div>
              <div><span class="box">X</span> Sonido [cite: 103]</div>
              <div><span class="box">X</span> Video [cite: 104]</div>
              <div><span class="box">X</span> Red [cite: 106]</div>
            </div>

            <table class="border-table" style="margin-top: 5px;">
              <tr><td class="bg-gray">CONCLUSIÓN [cite: 100]</td><td>${i.conclusion || ''}</td></tr>
              <tr><td class="bg-gray">RECOMENDACIÓN [cite: 101]</td><td>${i.recomendacion_tecnica || ''} [cite: 87]</td></tr>
            </table>

            <table class="signature-table">
              <tr>
                <td><div class="sig-line"></div><b>TÉCNICO ASIGNADO</b><br>${i.tecnico_nombre} [cite: 63]</td>
                <td><div class="sig-line"></div><b>ENTREGUE CONFORME</b><br>${i.tecnico_nombre} [cite: 109]</td>
                <td><div class="sig-line"></div><b>RECIBI CONFORME</b><br>${i.verificado_por} [cite: 115]</td>
              </tr>
            </table>
          </div>
        </body>
      </html>
    `;
  }
};